import React, { useEffect, useRef } from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import ReviewRating from './ReviewRating';
import { Box, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ReviewName from './ReviewName';
import ReviewProfile from './ReviewProfile';
import ReviewComments from './ReviewComments';
import ReviewTime from './ReviewTime';
import { decrypt } from '../../../utils/cryptoUtils';
import google from "../../../assets/google.png";
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import "@splidejs/splide/dist/css/splide.min.css";
import '@splidejs/react-splide/css';
 
function CardList({ GoogleReviews, layout }) {
  const theme = useTheme();
  const cardContainerRef = useRef(null);
 
  const getComment = (encryptedData) => {
    const jsonString = decrypt(encryptedData);
    const jsonObject = JSON.parse(jsonString);
    return jsonObject;
  };
 
  // useEffect(() => {
  //   const startAutoScroll = () => {
  //     const splideInstance = cardContainerRef.current.splide;
  //     splideInstance && splideInstance.go('+1');
  //   };
  //   const timeoutId = setTimeout(startAutoScroll, 3000);

  //   return () => {
  //     clearTimeout(timeoutId);
  //     const splideInstance = cardContainerRef.current.splide;
  //     splideInstance && splideInstance.destroy();
  //   };
  // }, []);
 
 
  const renderCards = () => {
    return GoogleReviews.map((data, index) => (
      <SplideSlide key={index}>
        <Stack
          sx={{
            border: "0px #C1c1c1 solid",
            borderRadius: "1vw",
            background: "linear-gradient(to bottom, #FEE6E3, #FCF9F3)",
            marginBottom:"15px",
            [theme.breakpoints.up('xl')]: {
              width: '31vw',
              padding: '0.9vw',
            },
          }}
          p={2}
          gap={1}
          mb={2}
        >
          <Stack
            alignItems="center"
            justifyContent="space-between"
            direction="row"
          >
            <ReviewTime layout={layout} time={data.ReviewTime} />
            <img style={{ width: "2vw" }} src={google} alt="Google icon" />
          </Stack>
          <Stack
            alignItems="left"
            justifyContent="space-between"
            direction="row"
            gap={1}
          >
            <Stack alignItems="center" direction="row" gap={1} >
              <ReviewProfile layout={layout} profileUrl={(getComment(data.ReviewComment)).UserInfo.profilePhotoUrl} />
              <ReviewName layout={layout} name={(getComment(data.ReviewComment)).UserInfo.displayName} />
            </Stack>
            <ReviewRating rating={data.Ratting} />
          </Stack>
          <ReviewComments layout={layout} comment={getComment(data.ReviewComment).Comment} />
        </Stack>
      </SplideSlide>
    ));
  };
 
  return (
    <Splide
  options={{
    type: "loop",
    drag: "free",
    arrows: false,
    pagination: false,
    direction: "ttb",
    autoHeight: true,
    height: "84vh",
    autoScroll: {
      pauseOnHover: false,
      pauseOnFocus: false,
      rewind: false,
      speed: 0.2
    },
    // transition: "fade", // Try different values like "fade", "slide", etc.
    ease: "cubic-bezier(.42,.65,.27,.99)", // Experiment with easing functions.
  }}
  extensions={{ AutoScroll }}
  ref={cardContainerRef}
>
    {renderCards()}
  </Splide>
  );
}
 
export default CardList;